/*
 * @Author: Dong
 * @Date: 2022-05-07 14:48:34
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-11-24 17:10:29
 */
import React, { forwardRef, useImperativeHandle } from 'react';
import { useIntl } from 'react-intl';
import { Form, Input, DatePicker } from 'sup-ui';
import { FormComponentProps } from 'sup-ui/lib/form/Form';
import messages from '../messages';
import moment from 'moment';
import styles from './AutoBackupForm.less';

interface FCFormProps extends FormComponentProps {
  data?: any;
}

const formItemLayout = {
  labelCol: {
    sm: { span: 4 },
  },
  wrapperCol: {
    sm: { span: 20 },
  },
};

const AutoBackupForm = forwardRef<FormComponentProps, FCFormProps>((props, ref) => {
  const intl = useIntl();
  const { form, data } = props;
  const { getFieldDecorator } = form;

  useImperativeHandle(ref, () => ({
    form,
  }));

  // 不允许选择的日期
  const disabledStartDate = (current: any) => {
    const curDate = new Date().getTime() - 3 * 1000;
    return current && current < moment(curDate);
  };
  const range = (start: any, end: any) => {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  };
  // 不允许选择的时间
  const disabledTime = (current: any) => {
    const curDate = new Date().getTime() - 3 * 1000;
    if (new Date(current) > new Date(moment(curDate) as any)) return;
    if (moment(current._d).isSame(curDate, 'd')) {
      const date = new Date(curDate);
      const h = date.getHours();
      const m = date.getMinutes();
      const s = date.getSeconds();

      return {
        disabledHours: () => range(0, h),
        disabledMinutes: () => range(0, m),
        disabledSeconds: () => range(0, s),
      };
    }
  };

  return (
    <Form className={styles.form} {...formItemLayout}>
      <Form.Item className={styles.formSavePath} label={intl.formatMessage(messages.savePath)}>
        {getFieldDecorator('filePath', {
          initialValue: data?.filePath,
        })(<Input disabled />)}
      </Form.Item>

      <Form.Item className={styles.autoBackupItem} colon={false} label={intl.formatMessage(messages.autoBackup)}>
        <p className={styles.autoBackupLine} />
      </Form.Item>

      <Form.Item label={intl.formatMessage(messages.startTime)}>
        {getFieldDecorator('startTime', {
          initialValue: data?.startTime ? moment(data?.startTime) : undefined,
          rules: [
            {
              validator: async (rule: any, value: string, callback: () => void) => {
                const curDate = new Date().getTime();
                if (!value) throw new Error(intl.formatMessage(messages.startTimeRequired));
                if (curDate > Number(value)) throw new Error(intl.formatMessage(messages.dateError));
                return callback();
              },
            },
          ],
        })(
          <DatePicker
            style={{ width: '100%' }}
            format="YYYY[年]M[月]D[日] HH:mm"
            disabledDate={disabledStartDate}
            disabledTime={disabledTime}
            showTime={{ format: 'HH:mm' }}
          />,
        )}
      </Form.Item>

      <Form.Item label={intl.formatMessage(messages.syncTimes)}>
        {getFieldDecorator('intervalTimes', {
          initialValue: data?.intervalTimes,
          rules: [
            {
              required: true,
              message: intl.formatMessage(messages.syncTimesRule),
            },
            {
              pattern: new RegExp(/^[0-9]\d*$/),
              message: intl.formatMessage(messages.syncTimesRule),
            },
          ],
        })(
          <Input
            suffix={intl.formatMessage(messages.syncTimesUnit)}
            maxLength="64"
            placeholder={intl.formatMessage(messages.placeholdersSyncTimesUnit)}
          />,
        )}
      </Form.Item>

      <Form.Item label={intl.formatMessage(messages.saveCount)}>
        {getFieldDecorator('retainCount', {
          initialValue: data?.retainCount || 1,
          rules: [
            {
              required: true,
              message: intl.formatMessage(messages.saveCountRule),
            },
            {
              pattern: new RegExp(/^[1-7]{1}$/),
              message: intl.formatMessage(messages.saveCountRule),
            },
          ],
        })(
          <Input
            suffix={intl.formatMessage(messages.saveCountUnit)}
            maxLength="64"
            placeholder={intl.formatMessage(messages.placeholderSaveCountUnit)}
          />,
        )}
      </Form.Item>
    </Form>
  );
});

export default Form.create()(AutoBackupForm);
